import React, { useEffect, useState } from "react";
import { Button, Modal, Tabs } from "antd";
import ReactDOM from "react-dom";
import { CreateTeamAndEmployee } from "@/types/LoginPage";
import bus from "@/utils/bus";
import "./index.less";
import infoPng from "@/assets/img/info.png";
import { useTranslation } from "react-i18next";
import JoinTeam from "../JoinTeam";

export default function CreateTeamWithLoginModal() {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation("common");

  useEffect(() => {
    // console.log("CreateTeamWithLogin>ls1");
    const changeVisible = (visible = true) => {
      // console.log("CreateTeamWithLoginVisible>ls1");
      setVisible(visible);
    };
    bus.on("CreateTeamWithLoginVisible", changeVisible);
    return () => {
      bus.off("CreateTeamWithLoginVisible", changeVisible);
    };
  }, []);
  if (!visible) return null;
  return (
    <Modal
      className="CreateTeamWithLogin"
      destroyOnClose
      maskClosable={false}
      closable={true}
      width={400}
      centered={true}
      title={null}
      footer={null}
      visible={visible}
      onCancel={() => {
        setVisible(false);
      }}
    >
      <div className="CreateTeamWithLogin-body">
        <JoinTeam
          isLogin={false}
          //   onCloseModal={() => {
          //     setVisible(false);
          //   }}
        />
      </div>
    </Modal>
  );
}
